const components = {
  //
  //  +===========+
  //  |  HEADING  |
  //  +===========+

  Heading: {
    baseStyle: {
      fontWeight: "bold",
      marginBottom: 0,
    },
    variants: {
      /* HDS h1 */
      "80/88": {
        fontSize: "80px",
        lineHeight: "88px",
      },
      /* HDS h2 */
      "56/64": {
        fontSize: "56px",
        lineHeight: "64px",
      },
      /* HDS h3 */
      "40/44": {
        fontSize: "40px",
        lineHeight: "44px",
      },
      /* HDS h4 */
      "32/36": {
        fontSize: "32px",
        lineHeight: "36px",
      },
      /* HDS h5 */
      "24/28": {
        fontSize: "24px",
        lineHeight: "28px",
      },
    },
  },

  //  +========+
  //  |  TEXT  |
  //  +========+

  Text: {
    variants: {
      "12/16": {
        fontSize: "12px",
        lineHeight: "16px",
      },
      /* HDS paragraph sm */
      "14/20": {
        fontSize: "14px",
        lineHeight: "20px",
      },
      /* HDS paragraph sm */
      "16/24": {
        fontSize: "16px",
        lineHeight: "24px",
      },
      /* HDS paragraph md */
      "18/28": {
        fontSize: "18px",
        lineHeight: "28px",
      },
      /* HDS paragraph lg */
      "20/32": {
        fontSize: "20px",
        lineHeight: "32px",
      },
      /* HDS paragraph xl */
      "24/36": {
        fontSize: "24px",
        lineHeight: "36px",
      },
      /* HDS paragraph xxl */
      "32/48": {
        fontSize: "32px",
        lineHeight: "48px",
      },

      /* HDS label xs */
      "14/14": {
        fontSize: "14px",
        lineHeight: "14px",
      },
      /* HDS label sm */
      "18/18": {
        fontSize: "18px",
        lineHeight: "18px",
      },
      /* HDS label md */
      "20/20": {
        fontSize: "20px",
        lineHeight: "20px",
      },
      /* HDS label lg */
      "28/28": {
        fontSize: "28px",
        lineHeight: "28px",
      },

      /* HDS button default */
      "18/24": {
        fontSize: "18px",
        lineHeight: "24px",
      },
      "20/30": {
        fontSize: "20px",
        lineHeight: "30px",
      },

      /* HDS mobile h3 */
      "24/28": {
        fontSize: "24px",
        lineHeight: "28px",
      },
      /* HDS web h3 */
      "32/36": {
        fontSize: "32px",
        lineHeight: "36px",
      },
    },
  },

  //  +==========+
  //  |  BUTTON  |
  //  +==========+

  Button: {
    baseStyle: {
      rounded: "4px",
      fontWeight: "medium",
      transition:
        "background-color 250ms ease-in-out, color 250ms ease-in-out, box-shadow 250ms ease-in-out",
    },
    variants: {
      "solid.primary": {
        color: "#0D3050",
        bgColor: "rgba(249, 210, 9, 0.8)",
        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
        _hover: {
          bgColor: "#F9D209",
          boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
          color: "rgba(13, 48, 80, 0.8)",
          _disabled: {
            opacity: 0.6,
          },
        },
        _focus: {
          bgColor: "#F9D209",
          boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF",
        },
        _disabled: {
          bgColor: "primary.light",
          opacity: 0.6,
        },
        _active: {
          bgColor: "#F9D209",
          boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF",

          color: "#0D3050",

          border: "1px solid #F9D209",
        },
      },
      "link.default": {
        padding: 0,
        height: "min-content",
        color: "rgba(13,48,80,0.8)",
        _hover: {
          color: "rgb(13,48,80)",
        },
        _focus: {
          color: "rgb(13,48,80)",
        },
      },
      "outline.default": {
        border: "1px solid",
        borderColor: "rgba(240,237,236,0.4)",
        color: "rgba(13,48,80,0.6)",
        _hover: {
          borderColor: "rgba(240,237,236,0.4)",
          bgColor: "rgba(240,237,236,0.2)",
          color: "rgba(13,48,80,0.8)",
        },
        _focus: {
          borderColor: "rgba(240,237,236,0.4)",
          bgColor: "rgba(240,237,236,0.2)",
          color: "rgba(13,48,80,0.8)",
          _hover: {
            borderColor: "rgba(240,237,236,0.4)",
            bgColor: "rgba(240,237,236,0.2)",
            color: "rgba(13,48,80,0.8)",
          },
        },
        _disabled: {
          borderColor: "rgba(240,237,236,0.4)",
          color: "rgba(240,237,236,0.4)",
          opacity: "1",
          backdropFilter: "blur(4px)",
          _hover: {
            borderColor: "rgba(240,237,236,0.4)",
            color: "rgba(240,237,236,0.4)",
            opacity: "1",
            backdropFilter: "blur(4px)",
          },
        },
      },
    },
    defaultProps: {
      variant: "solid.primary",
    },
  },

  //  +=========+
  //  |  INPUT  |
  //  +=========+

  Input: {
    baseStyle: {
      field: {
        transition: "border-color 250ms ease-in-out",
      },
    },
    variants: {
      outline: {
        field: {
          rounded: "4px",
          borderColor: "rgba(240,237,236,0.4)",
          _placeholder: {
            color: "rgba(13,48,80,0.6)",
          },
          _focus: {
            boxShadow: "none",
            borderColor: "primary.light",
          },
          _invalid: {
            boxShadow: "none",
            borderColor: "red.300",
            _focus: {
              borderColor: "red.300",
            },
          },
        },
      },
    },
  },

  //  +============+
  //  |  TEXTAREA  |
  //  +============+

  Textarea: {
    variants: {
      outline: {
        rounded: "4px",
        borderColor: "rgba(240,237,236,0.4)",
        _placeholder: {
          color: "rgba(13,48,80,0.6)",
        },
        _focus: {
          boxShadow: "none",
          borderColor: "primary.light",
        },
        _invalid: {
          boxShadow: "none",
          borderColor: "red.300",
          _focus: {
            borderColor: "red.300",
          },
        },
      },
    },
  },

  //  +=========+
  //  |  BADGE  |
  //  +=========+

  Badge: {
    baseStyle: {
      rounded: "16px",
      fontWeight: "medium",
      textTransform: "unset",
    },
    variants: {
      primary: {
        bgColor: "#B1FCBB",
        color: "#4D8053",
      },
    },
  },

  //  +=========+
  //  |  MODAL  |
  //  +=========+

  Modal: {
    baseStyle: {
      overlay: {
        bgColor: "rgba(52, 64, 84, 0.7)",
        backdropFilter: "blur(8px)",
      },
      dialog: {
        borderRadius: "12px",
      },
    },
  },

  //  +==========+
  //  |  DRAWER  |
  //  +==========+

  Drawer: {
    baseStyle: {
      overlay: {
        bgColor: "rgba(52, 64, 84, 0.7)",
      },
    },
  },

  //  +=========+
  //  |  TABLE  |
  //  +=========+

  Table: {
    variants: {
      unstyled: {
        table: {
          tableLayout: "fixed",
          thead: {
            th: {
              fontFamily: "'Helvetica Neue', sans-serif",
              fontWeight: "medium",
              textTransform: "none",
            },
          },
        },
      },
    },
  },
};

export default components;
